import './LoginPage.css';
import { React, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faUser , faPhone} from '@fortawesome/free-solid-svg-icons';

function RegisterPage() {
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [otpSent,setOtpSent] = useState(false);
  const [verificationToken, setVerificationToken] = useState(null);
  const [whatsapp, setWhatsapp] = useState('');
  if(localStorage.getItem('token')){
    window.location.href = '/';
    return (<div className="App container"></div>)
  }

  function togglePassword() {
    setShowPassword(showPassword => !showPassword);
  }

  function toggleConfirmPassword() {
    setShowConfirmPassword(showConfirmPassword => !showConfirmPassword);
  }

  function toggleTermsModal() {
    setShowTermsModal(show => !show);
  }
  function verifyOtp(whatsapp, otp) {
    axios.post('https://rechargemoi.ma/backend/api/verify_otp', { whatsapp, otp }, {}).then((res) => {
      const js = res.data;
      if (res.status === 200 || res.status === 201) {
        setWhatsapp(whatsapp);
        setVerificationToken(js.verification_token);
        alert('تم التحقق بنجاح. يمكنك الآن إكمال التسجيل.');
      }
    }).catch((err) => {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError("حدث خطأ أثناء التحقق. يرجى المحاولة مرة أخرى");
      }
    });
  }
  function requestOtp(whatsapp) {
    setWhatsapp(whatsapp);
    if (!/^0[67][0-9]{8}$/.test(whatsapp)) {
      alert('رقم الواتس اب غير صالح. يجب أن يبدأ بـ 06 أو 07 ويتكون من 10 أرقام.');
      return;
    }
    axios.post('https://rechargemoi.ma/backend/api/request_otp', { whatsapp }, {}).then((res) => {
      const js = res.data;
      if (res.status === 200 || res.status === 201) {
        setOtpSent(true);
      } else {
        setError(js.message || 'حدث خطأ أثناء إرسال رمز التحقق');
      }
    }).catch((err) => {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError("حدث خطأ أثناء إرسال رمز التحقق. يرجى المحاولة مرة أخرى");
      }
    });
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if(verificationToken == null){
      setError('يجب التحقق من رقم الواتس اب قبل المتابعة');
      return;
    }
    // Check terms agreement
    if (!agreedToTerms) {
      setError('يجب الموافقة على الشروط والأحكام للمتابعة');
      return;
    }
    
    const data = new FormData(e.target);
    const password = data.get('password');
    const confirmPassword = data.get('confirm_password');

    
    // Validate password match
    if (password !== confirmPassword) {
      setError('كلمات المرور غير متطابقة');
      return;
    }
    
    // Validate password length (minimum 8 characters)
    if (password.length < 8) {
      setError('كلمة المرور يجب أن تكون 8 أحرف على الأقل');
      return;
    }
    
    const firstName = data.get('first_name');
    const lastName = data.get('last_name');
    const fullName = `${firstName} ${lastName}`.trim();
    
    const postData = {
      name: fullName,
      email: data.get('email'),
      whatsapp: whatsapp,
      password: password,
      password_confirmation: confirmPassword,
      verification_token: verificationToken
    };
    
    axios.post('https://rechargemoi.ma/backend/api/register', postData, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => {
      const js = res.data;
      if (res.status === 200 || res.status === 201) {
        localStorage.setItem('token', js.token);
        window.location.href = '/';
      } else {
        setError(js.message || 'حدث خطأ أثناء التسجيل');
        console.log('Error message:', js.message);
      }
    }).catch((err) => {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else if (err.response && err.response.data && err.response.data.errors) {
        // Handle validation errors
        const errors = Object.values(err.response.data.errors).flat();
        setError(errors.join(', '));
      } else {
        setError("حدث خطأ أثناء التسجيل. يرجى المحاولة مرة أخرى");
      }
    });
  }

  return (
    <div className="App container" dir="rtl">
        <img src="logo.jpeg" alt="الشعار" id='logo' height={100} width={100} />
        <h2 className="login-title">إنشاء حساب جديد</h2>
        
      <form method='POST' onSubmit={handleSubmit} className="mt-5">
        {/* First Name Field */}
        <label>الاسم الشخصي</label>
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faUser} />
            </span>
          </div>
          <input 
            type="text" 
            className="form-control" 
            id="first_name" 
            name="first_name" 
            placeholder="الاسم الشخصي"
            required 
            minLength={2}
          />
        </div>
        
        {/* Last Name Field */}
        <label>الاسم العائلي</label>
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faUser} />
            </span>
          </div>
          <input 
            type="text" 
            className="form-control" 
            id="last_name" 
            name="last_name" 
            placeholder="الاسم العائلي"
            required 
            minLength={2}
          />
        </div>
        <label>رقم هاتف الواتس اب (يجب أن يبدأ بـ 06 أو 07)</label>
        {/* WhatsApp Number Field */}
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <FontAwesomeIcon icon={faPhone} />
                </span>
              </div>
              <input 
                type="text" 
                className="form-control" 
                id="whatsapp" 
                name="whatsapp" 
                disabled={verificationToken != null ? true : false}
                placeholder="رقم هاتف الواتس اب"
                pattern='^0[67][0-9]{8}$'
                required 
                minLength={10}
                maxLength={10}
              />
            </div>
            <div className="d-grid gap-2 mt-2 mb-3">
              <button 
                type="button"
                className="btn btn-info"
                style={{ backgroundColor: '#17B817', borderColor: '#17a2b8' , color: 'white'}}
                onClick={() => requestOtp(document.getElementById('whatsapp').value)}
              >
                إرسال رمز التحقق
              </button>
            </div>
              {(otpSent && verificationToken == null) && <p className="success-message">تم إرسال رمز التحقق بنجاح إلى رقم الواتس اب الخاص بك.</p>}
              {(otpSent && verificationToken == null) && <div className="input-group">
                <input 
                  type="text" 
                  className="form-control" 
                  id="otp" 
                  name="otp" 
                  placeholder="رمز التحقق"
                  required 
                />
              </div>}
              {(otpSent && verificationToken == null) && <div className="d-grid gap-2 mt-2 mb-3">
                <button 
                  type="button"
                  className="btn btn-success"
                  style={{ backgroundColor: '#28a745', borderColor: '#28a745' , color: 'white'}}
                  onClick={() => verifyOtp(document.getElementById('whatsapp').value, document.getElementById('otp').value)}
                >
                  تحقق
                </button>
              </div>}
            <label>البريد الإلكتروني</label>
            {/* Email Field */}
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faEnvelope} />
            </span>
          </div>
          <input 
            type="email" 
            className="form-control" 
            id="email" 
            name="email" 
            placeholder="البريد الإلكتروني"
            required 
          />
        </div>
        <label>كلمة المرور (8 أحرف على الأقل)</label>
        {/* Password Field */}
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faLock} />
            </span>
          </div>
          <input 
            type={showPassword ? "text" : "password"}  
            className="form-control" 
            id="password" 
            name="password" 
            placeholder="كلمة المرور (8 أحرف على الأقل)"
            required 
            minLength={8}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i 
                className={showPassword ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"} 
                style={{ color: '#8b2881', cursor: 'pointer' }}
                onClick={togglePassword}
                title={showPassword ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"}
              ></i>
            </span>
          </div>
        </div>
        <label>تأكيد كلمة المرور</label>
        {/* Confirm Password Field */}
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faLock} />
            </span>
          </div>
          <input 
            type={showConfirmPassword ? "text" : "password"}  
            className="form-control" 
            id="confirm_password" 
            name="confirm_password" 
            placeholder="تأكيد كلمة المرور"
            required 
            minLength={8}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i 
                className={showConfirmPassword ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"} 
                style={{ color: '#8b2881', cursor: 'pointer' }}
                onClick={toggleConfirmPassword}
                title={showConfirmPassword ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"}
              ></i>
            </span>
          </div>
        </div>
        
        {/* Terms and Conditions Checkbox */}
        <div className="mt-3 mb-3" style={{ display: 'flex', alignItems: 'flex-start', textAlign: 'right', gap: '10px', flexDirection: 'row-reverse' }}>
          <input 
            type="checkbox" 
            id="termsCheckbox"
            checked={agreedToTerms}
            onChange={(e) => setAgreedToTerms(e.target.checked)}
            style={{ marginTop: '5px', cursor: 'pointer', flexShrink: 0 }}
          />
          <label htmlFor="termsCheckbox" style={{ cursor: 'pointer', flex: 1 }}>
            أوافق على   
           <button type="button" onClick={toggleTermsModal} style={{ background: 'none', border: 'none', color: '#8b2881', fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer', padding: '0' }}>الشروط والأحكام</button>
            {' '}(يجب قراءة الشروط قبل التسجيل)
          </label>
        </div>
        
        <div className="d-grid gap-2">
          <button type="submit" className="btn btn-primary" id='login'>إنشاء حساب</button>
          {error && <p id="error" className="error-message">{error}</p>}
        </div>
        
        <div className="text-center mt-3">
          <p>لديك حساب بالفعل؟ <a href="/login" style={{ color: '#8b2881', fontWeight: 'bold' }}>تسجيل الدخول</a></p>
        </div>
      </form>
      <br />
       <br />
      <iframe width="337" height="599" src="https://www.youtube.com/embed/2tRLnedHusU" title="شرح موقع rechargemoi.ma" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      
      {/* Terms Modal */}
      {showTermsModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={toggleTermsModal}>
          <div className="modal-dialog modal-dialog-scrollable modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content" dir="rtl">
              <div className="modal-header" style={{ borderBottom: '2px solid #8b2881' }}>
                <h3 className="modal-title" style={{ color: '#8b2881' }}>الشروط والأحكام</h3>
                <button type="button" className="btn-close" onClick={toggleTermsModal} style={{ marginLeft: 'auto' }}></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                
                <div className="terms-section" style={{ marginBottom: '20px', backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
                  <h5 style={{ color: '#8b2881', marginBottom: '10px' }}>📱 عن الخدمة</h5>
                  <p style={{ fontSize: '15px', lineHeight: '1.8' }}>
                    هذا الموقع مخصص لتعبئات <strong>إنوي (inwi)</strong> فقط.
                  </p>
                </div>

                <div className="terms-section" style={{ marginBottom: '20px', backgroundColor: '#fff3cd', padding: '15px', borderRadius: '8px', border: '2px solid #ffc107' }}>
                  <h5 style={{ color: '#8b2881', marginBottom: '10px' }}>⚠️ تحذير مهم - لا يمكن الإرجاع</h5>
                  <p style={{ fontSize: '15px', lineHeight: '1.8', color: '#856404' }}>
                    <strong>في حالة إتمام التعبئة بنجاح، لا يمكن إرجاعها أو استرداد المبلغ.</strong>
                  </p>
                  <p style={{ fontSize: '15px', lineHeight: '1.8', color: '#856404' }}>
                    لا يوجد تعويض. يرجى التأكد جيداً من:
                  </p>
                  <ul style={{ fontSize: '15px', lineHeight: '1.8', color: '#856404' }}>
                    <li>الرقم الذي ستقوم بإرسال التعبئة إليه</li>
                    <li>العرض المختار (*6، *3...إلخ)</li>
                    <li>المبلغ المطلوب</li>
                  </ul>
                </div>

                <div className="terms-section" style={{ marginBottom: '20px', backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
                  <h5 style={{ color: '#8b2881', marginBottom: '10px' }}>📵 ملاحظة حول بعض الأرقام</h5>
                  <p style={{ fontSize: '15px', lineHeight: '1.8' }}>
                    هناك بعض الأرقام التي قد لا تقبل التعبئة بهذه الطريقة. 
                  </p>
                </div>

                <div className="terms-section" style={{ marginBottom: '20px', backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
                  <h5 style={{ color: '#8b2881', marginBottom: '10px' }}>💰 نسبة الربح</h5>
                  <p style={{ fontSize: '15px', lineHeight: '1.8' }}>
                    نسبة الربح المضافة هي <strong>10%</strong> على جميع التعبئات.
                  </p>
                </div>

                <div className="terms-section" style={{ marginBottom: '20px', backgroundColor: '#e7f3ff', padding: '15px', borderRadius: '8px', border: '2px solid #0d6efd' }}>
                  <h5 style={{ color: '#8b2881', marginBottom: '10px' }}>🏦 طرق الدفع المتاحة</h5>
                  <p style={{ fontSize: '15px', lineHeight: '1.8' }}>
                    يمكنك الإرسال إلى أي من البنوك التالية (اختر الأقرب إليك):
                  </p>
                  <ul style={{ fontSize: '15px', lineHeight: '1.8' }}>
                    <li>💳 <strong>بريد بنك</strong> (Barid Bank)</li>
                    <li>💳 <strong>البنك التجاري وفا بنك</strong> (Attijariwafa Bank)</li>
                    <li>💳 <strong>سي آي إتش بنك</strong> (CIH Bank)</li>
                    <li>💳 <strong>البنك الشعبي</strong> (Banque Populaire)</li>
                  </ul>
                </div>

                <div className="terms-section" style={{ marginBottom: '20px', backgroundColor: '#d4edda', padding: '15px', borderRadius: '8px', border: '2px solid #28a745' }}>
                  <h5 style={{ color: '#8b2881', marginBottom: '10px' }}>✅ بالمتابعة، أنت توافق على</h5>
                  <ul style={{ fontSize: '15px', lineHeight: '1.8' }}>
                    <li>أنك قرأت وفهمت جميع الشروط المذكورة أعلاه</li>
                    <li>أنك تتحمل مسؤولية التأكد من صحة البيانات المدخلة</li>
                    <li>أنك تقبل عدم إمكانية إرجاع التعبئة بعد إتمامها</li>
                    <li>أنك على علم بنسبة الربح المضافة 10%</li>
                  </ul>
                </div>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={toggleTermsModal}>إغلاق</button>
                <button type="button" className="btn btn-primary" onClick={() => { setAgreedToTerms(true); toggleTermsModal(); }} style={{ backgroundColor: '#8b2881', borderColor: '#8b2881' }}>موافق وإغلاق</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RegisterPage;